import { AugmentationPanelItemProps } from "@pathwright/ux/src/components/augmentation/AugmentationPanelSection"
import { useMemo } from "react"
import { useCoverPageContext } from "../CoverPageProvider"
import { CoverPagePanelSection } from "../types"
import { useCoverPageTranslate } from "../utils"
import { requestCoverPageInlineSectionEdit } from "./CoverPageInlineSectionEditor"
import { CoverPagePanelSectionBlock } from "./CoverPagePanelSection"

export function CoverPagePanelPitchSection() {
  const resource = useCoverPageContext((value) => value.resource)
  const { t } = useCoverPageTranslate()

  const items: AugmentationPanelItemProps[] = useMemo(
    () => [
      {
        itemKey: "edit-title-images",
        icon: "image",
        label: t("panel_pitch.edit_title_images", {
          defaultValue: "Edit title, images..."
        }),
        panelRoute: "/header"
      },
      {
        itemKey: "edit-description",
        icon: "edit",
        label: resource?.description
          ? t("panel_pitch.edit_overview", { defaultValue: "Edit overview..." })
          : t("panel_pitch.add_overview", { defaultValue: "Add overview" }),
        hashKey: "description",
        onClick: () =>
          requestCoverPageInlineSectionEdit(CoverPagePanelSection.Description)
      },
      {
        itemKey: "add-steps-to-preview",
        icon: "plus",
        label: t("panel_sections.add_steps_to_preview", {
          defaultValue: "Add steps to preview"
        }),
        panelRoute: "/preview",
        hashKey: "preview"
      }
    ],
    [resource?.description, t]
  )

  return (
    <CoverPagePanelSectionBlock
      heading={t("panel_sections.header", { defaultValue: "Header" })}
      sectionKey="header"
      items={items}
    />
  )
}
